/**
 * Analyst Performance role actions.
 *
 * Unlike the Result Audit / Time Machine / Pipeline families, this one gates a REAL backend
 * boundary: `api.query`'s `ResultAnalystController` carries `[HasAction(ActionKeys.AnalystPerformance)]`
 * on all three endpoints, so the server enforces it whether or not the UI does.
 *
 * The key is deliberately NOT one of the `result_verification_*` family.
 * `ResultAnalystBootstrapHostedService` grants those to the Result Analyst role, so gating this
 * surface on any of them would let every analyst pull every peer's median decision time and
 * overturn rate. `PermissionBootstrapHostedService` seeds this key to admin roles only, which is
 * exactly the audience.
 *
 * Mirrors `iElect.ServiceDefaults/Authorization/ActionKeys.cs`. Adding a key here does nothing
 * until it is also added there and the api.core image has rolled — and the claim only reaches a
 * user on their NEXT login, because the JWT is a snapshot.
 */
export const ACTIONS_ANALYST_PERFORMANCE = {
	ANALYST_PERFORMANCE: 'analyst_performance',
} as const;
